const getScreenWidth = () => (window.visualViewport ? window.visualViewport.width : window.innerWidth);

export default {
    state: () => ({
        screenWidth: getScreenWidth(),
        loader: false,
    }),
    mutations: {
        /** change screenWidth **/
        ['global/changeScreenWidth']: (state) => {
            state.screenWidth = getScreenWidth();
        },
        /**
         * @param {string|object} payload - parent selector for preloader default: document.querySelector('body').
         */
        ['global/loaderStart']: (state, payload) => {
            state.loader = true;
        },
        ['global/loaderStop']: (state) => {
            state.loader = false;
        },
        ['global/loaderLog']: (state) => {
            //console.log(state.loader)
        }
    }
}